// extracted by mini-css-extract-plugin
module.exports = {"root":"UploaderFileList_root__2-u-e","list":"UploaderFileList_list__2r6b5"};